import {Skeleton, Stack} from "@mui/material";
import React from "react";

interface Props {
  testId: string;
}

const CheckboxSkeleton = ({
  testId
}: Props) => (
  <Stack
    width="100%"
    direction="row"
    gap="0.8rem"
    data-testid={`${testId}_checkbox-skeleton`}
  >
    <Skeleton variant="rounded" height="2rem" width="2rem" />
    <Skeleton width="100%" height="2rem" />
  </Stack>
);

export default CheckboxSkeleton;